import { TokenResponse } from '../../management/authentication/token-response.js';
import { literal } from '../../typing/literal.js';
import { object } from '../../typing/object.js';

export const AuthDeviceTokenResponse = object('AuthDeviceTokenResponse', {
  type: literal('token'),
  token: TokenResponse,
});
